<template>
    <div>
        <div class="modal-header">
            <h2 class="text-center">{{deleteText}}</h2>
        </div>

        <div class="modal-footer">
            <div class="text-center modal-buttons">
                <button type="button" class="button-green" @click="closeEnquiry()">Ja</button>
                <button type="button" class="button-red" @click="closeModal()">Nej</button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    name: 'enquiry-modal-delete',
    data () {
        return {
            deleteText: 'Vil du slette henvendelsen?'
        }
    },
    props: {
        data: Object
    },
    methods: {
        ...mapActions({
            setDeleteEnquiry: 'setDeleteEnquiry'
        }),
        closeEnquiry () {
            this.deleteText = 'Sletter henvendelse...'
            this.setDeleteEnquiry(this.data.enquiry.requestId).then((response) => {
                if (response) {
                    this.$router.push({
                        name: 'dashboard'
                    })
                }
            }, error => {
                console.error('error', error)
            })
        },
        closeModal () {
            this.$emit('close')
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/pages/enquiry/enquiry-modal-delete.vue